import Layout from '@layout/Index'

export const customerReceipt = [
  {
    path: '/customer-receipt',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "customer-receipt-table" */ './pages/CustomerReceiptTable.vue'),
        meta: {
          title: '客户开票信息列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "customer-receipt-form" */ './pages/CustomerReceiptForm.vue'),
        meta: {
          title: '添加客户开票信息',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "customer-receipt-form" */ './pages/CustomerReceiptForm.vue'),
        meta: {
          title: '修改客户开票信息',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "customer-receipt-detail" */ './pages/CustomerReceiptDetail.vue'),
        meta: {
          title: '客户开票信息详情',
        },
      },
      {
        path: 'batch/create',
        component: () => import(/* webpackChunkName: "customer-receipt-detail" */ './pages/CustomerReceiptBatchForm.vue'),
        meta: {
          title: '批量添加客户开票信息',
          isUpdate: false,
        },
      },
      {
        path: 'batch/update',
        component: () => import(/* webpackChunkName: "customer-receipt-detail" */ './pages/CustomerReceiptBatchForm.vue'),
        meta: {
          title: '批量更新客户开票信息',
          isUpdate: true,
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/customer-receipt/customer-receipt.route.js